// Add your javascript here
// Don't forget to add it into respective layouts where this js file is needed

$(document).ready(function () {
  AOS.init({
    // uncomment below for on-scroll animations to played only once
    // once: true  
  }); // initialize animate on scroll library

  $(".navbar-toggle").click(function () {
    $(this).children('.fas').toggleClass('fa-chevron-down fa-chevron-up');
  });

  $(function () {
    
    var element = $("#dback");
    var backgrounds = [
        'url("assets/images/IMG_20190512_151552_559.jpg")',
        'url("assets/images/IMG_20171119_111418_365.jpg")',
        'url("assets/images/IMG_20190908_141210_952.jpg")',
        'url("assets/images/IMG-20190923-WA0003.jpg")']
        
    var current = 0;

    function nextBackground() {
      $('#dback').fadeTo(300, 0.1, function()
      {
        element.css(
            'background-image',
        backgrounds[current = ++current % backgrounds.length]);

        setTimeout(nextBackground, 8000);
      }).fadeTo(300, 1);
    }
    setTimeout(nextBackground, 8000);
    element.css('background-image', backgrounds[0]);
   
  });

});

// Smooth scroll for links with hashes
$('a.smooth-scroll')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
